import { render, staticRenderFns } from "./AuthSignupImage.vue?vue&type=template&id=6745340c&scoped=true"
import script from "./AuthSignupImage.vue?vue&type=script&lang=js"
export * from "./AuthSignupImage.vue?vue&type=script&lang=js"
import style0 from "./AuthSignupImage.vue?vue&type=style&index=0&id=6745340c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6745340c",
  null
  
)

export default component.exports